// User Types (fee-based model — no subscriptions)

export interface User {
  walletAddress: string;
  createdAt: string;
  usage: UsageStats;
}

export interface UsageStats {
  totalLookups: number;
  totalTrades: number;
  totalVolumeUsd: number;
}

// Fee configuration
export const TRADE_FEE_BPS = 100; // 1% on every buy and sell

// Abuse-prevention limits (not monetization gates)
export const ABUSE_LIMITS = {
  dailyLookups: 200, // per IP, not per wallet
  dailySimulations: 100,
} as const;

export interface WatchlistItem {
  type: 'token' | 'wallet';
  address: string;
  label?: string;
  addedAt: string;
  alerts: AlertType[];
}

export type AlertType =
  | 'large_trade'
  | 'creator_movement'
  | 'whale_entry'
  | 'whale_exit'
  | 'price_change'
  | 'holder_change';
